/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var warning = require('../internal/warning.js');

const didWarnAboutDeprecation = {};
function deprecateValuesWithin(propType, allowedValues, propMappingFunction) {
  return function checker(props, propName, componentName) {
    if (props[propName] === undefined) {
      return;
    }
    if (!didWarnAboutDeprecation[componentName] || !didWarnAboutDeprecation[componentName][propName]) {
      didWarnAboutDeprecation[componentName] = {
        ...didWarnAboutDeprecation[componentName],
        [propName]: true
      };
      const deprecatedValue = props[propName];
      const newValue = propMappingFunction ? propMappingFunction(deprecatedValue) : null;
      if (allowedValues && !allowedValues.includes(deprecatedValue)) {
        const message = propMappingFunction ? `"${deprecatedValue}" is a deprecated value for the "${propName}" prop on the "${componentName}" component. Use "${newValue}" instead. "${deprecatedValue}" will be removed in the next major release.` : `"${deprecatedValue}" is a deprecated value for the "${propName}" prop on the "${componentName}" component. Allowed values is/are: ${allowedValues.join(', ')}.  "${deprecatedValue}" will be removed in the next major release. `;
        process.env.NODE_ENV !== "production" ? warning.warning(false, message) : void 0;
      }
    }
    for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      rest[_key - 3] = arguments[_key];
    }
    return propType(props, propName, componentName, ...rest);
  };
}

exports["default"] = deprecateValuesWithin;
